import React from "react";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TextField,
} from "@mui/material";

import { ELECTRICITY_TABLE_HEADERS } from "../../constant/TableHeaders";
import {
  StyledTableBody,
  TableBodyRow,
  TableHeaderRow,
} from "../../styles/TableStyles";

const TenantElectricityTable = ({
  tenants,
  tenantConsumption,
  handleConsumptionChange,
}) => {
  if (!tenants || tenants.length === 0) return null;

  return (
    <TableContainer sx={{ minHeight: 440 }}>
      <Table sx={{ minWidth: 500 }}>
        <TableHead>
          <TableHeaderRow>
            {ELECTRICITY_TABLE_HEADERS.map((item, index) => (
              <TableCell
                key={index}
                align={item.alignItemTo}
                sx={{ width: item.width }}
              >
                {item.title}
              </TableCell>
            ))}
          </TableHeaderRow>
        </TableHead>

        <StyledTableBody>
          {tenants.map((tenant) => (
            <TableBodyRow
              key={tenant.id}
              hover
              sx={{
                "&:hover": {
                  backgroundColor: "#f9f9f9",
                },
              }}
            >
              <TableCell sx={{ width: 100 }}>{tenant.id}</TableCell>
              <TableCell sx={{ width: 300 }}>
                {`${tenant.tenant_first_name} ${tenant.tenant_last_name}`}
              </TableCell>
              <TableCell sx={{ width: 500 }}>
                {tenant.electricity_per_unit_charge != null ? (
                  <TextField
                    type="number"
                    variant="filled"
                    label="Electricity Units"
                    value={tenantConsumption[tenant.id] || ""}
                    onChange={(e) => handleConsumptionChange(e, tenant.id)}
                    sx={{ width: 400 }}
                  />
                ) : (
                  <span>Fixed Bill: ₹ {tenant.monthly_electricity_bill}</span>
                )}
              </TableCell>
            </TableBodyRow>
          ))}
        </StyledTableBody>
      </Table>
    </TableContainer>
  );
};

export default TenantElectricityTable;
